module.exports = __webpack_public_path__ + "static/fonts/notokr-regular.a288961.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/survey2/font/notokr-regular.woff2
// module id = lWST
// module chunks = 0